// extracted by mini-css-extract-plugin
export default {"bookmarkChip":"Pg_7_4_bookmarkChip__BKEhM"};